import React from 'react'
import { Routes, Route } from 'react-router-dom'

// Import necessary components and pages
import Home from '../pages/home'
import Users from '../pages/users/index'
import UserDetails from '../pages/users/userDetails/index'
import UserForm from '../pages/users/userForm'

import Boats from '../pages/boats/index'
import BoatDetails from '../pages/boats/boatDetails/index'
import BoatForm from '../pages/boats/boatForm'
import CheckLists from 'pages/boats/checkList'
import DefectLists from 'pages/boats/defectList'
import CheckListDetails from 'pages/boats/checkList/details'
import DefectListDetails from 'pages/boats/defectList/details'

import MetroRoutes from '../pages/metroRoutes/index'
import MetroRouteDetails from '../pages/metroRoutes/metroRouteDetails'
import CaptainAssignmentDetails from '../pages/metroRoutes/captains/index'
import MetroRouteForm from '../pages/metroRoutes/metroRoutesForm'

import Locations from '../pages/locations/index'
import LocationForm from '../pages/locations/locationAddForm/index'
import LocationDetails from '../pages/locations/locationDetails/index'

import DayPass from '../pages/dayPass/index'
import DayPassForm from '../pages/dayPass/dayPassForm/index'
import DayPassDetails from '../pages/dayPass/dayPassDetails/index'

import MetroTripForm from '../pages/metroRoutes/metroTripForm'
import MetroTripDetails from '../pages/metroRoutes/metroTripDetails'

import CaptainScheduleForm from '../pages/metroRoutes/captainScheduleForm/index'
import BoatRouteAssignmentForm from '../pages/metroRoutes/assignBoatForm/index'

import CaptainRouteBoatHistory from '../pages/routeBoatHistory/index'
import RouteBoatDetails from '../pages/routeBoatHistory/routeBoatDetails/index'
import PassengerRecord from '../pages/passengerRecord/index'
import TripPassengerList from '../pages/passengerRecord/tripPassengerList/index'
import BoatBooking from '../pages/boatBooking/index'
import BoatBookingDetail from '../pages/boatBooking/boatDetail/index'
import BoatBookingConformation from '../pages/boatBooking/confirmation/index'
import RescheduleBooking from '../pages/boatBooking/reschedule'
import ManageBoatBooking from '../pages/manageBoatBooking/index'
import ManageBoatBookingDetail from '../pages/manageBoatBooking/bookingDetails/index'
import MetroRoutesMaster from '../pages/metroRoutesMaster/index'
import MetroRouteMasterForm from '../pages/metroRoutesMaster/metroRouteMasterForm'
import MetroRouteMasterDetails from '../pages/metroRoutesMaster/metroRouteMasterDetails'

import AppBanners from '../pages/banners/index'
import AppBannerForm from '../pages/banners/bannerForm'

import SystemConfig from 'pages/systemConfig'
import DiscountCodeForm from 'pages/systemConfig/discountCode/index'
import RecipientParties from 'pages/recipientParties/index'
import RecipientPartyForm from 'pages/recipientParties/recipientPartyForm/index'
import RecipientPartyDetails from 'pages/recipientParties/recipientPartyDetails/index'
import ShuttleServiceMaster from 'pages/shuttleServiceMaster/index'
import ShuttleServiceForm from 'pages/shuttleServiceMaster/shuttleServiceForm/index'
import ShuttleServiceDetails from 'pages/shuttleServiceMaster/shuttleServiceDetails/index'
import ShuttleServiceEditForm from 'pages/shuttleServiceMaster/shuttleServiceEditForm/index'

import Feedback from '../pages/feedback/index'
import FeedbackDetail from 'pages/feedback/details'
import { ProtectedRoute } from './ProtectedRoute'
import Reports from 'pages/reports'
import BookingReport from 'pages/reports/bookingReport'
import DayPassReport from 'pages/reports/dayPassReport'
import TripReport from 'pages/reports/tripReport'
import RouteUtilizationReport from 'pages/reports/routeUtilizationReport'
import StationRevenueReport from 'pages/reports/stationRevenueReport'
import FleetUtilizationReport from 'pages/reports/fleetUtilizationReport'
import HourlyBookingReport from 'pages/reports/hourlyBookingReport'
import Dashboard from 'pages/dashboard'
import CustomerFeedbackReport from 'pages/reports/customerFeedbackReport'
import NationalityPassengerReport from 'pages/reports/nationalityPassengerReport'
import AttractionsClicksReport from '../pages/reports/attractionsClicksReport'
import AppBannerClicksReport from 'pages/reports/appBannerClicks'

import WalletList from 'pages/wallets'
import WalletDetails from 'pages/wallets/walletDetails'
import RevenueDashboard from 'pages/dashboard/revenue_dashboard'
import Meals from 'pages/mealmaster'
import MealForm from 'pages/mealmaster/mealAddForm'
import MealDetails from 'pages/mealmaster/mealDetails'

// Explore Items
import ExploreItems from '../pages/exploreItems/index'
import ExploreItemForm from '../pages/exploreItems/exploreItemForm/index'
import ExploreItemDetails from '../pages/exploreItems/exploreItemDetails/index'

// Check-in
import CheckInPage from '../pages/checkIn/index'
import QRScannerPage from '../pages/checkIn/QRScannerPage'

// App Users
import AppUsers from '../pages/appUsers/index'
import UserBookings from '../pages/appUsers/bookings/index'
import AppUserDetails from '../pages/appUsers/userDetails/index'

// Send Notification
import SendNotification from '../pages/sendNotification/index'

// Subscriptions
import SubscriptionManagement from '../pages/subscriptions/index'
import SubscriptionForm from '../pages/subscriptions/subscriptionForm'

// Charter Boats
import CharterBoatsConfiguration from '../pages/charterBoats/configuration/index'
import ConfigurationForm from '../pages/charterBoats/configuration/configurationForm'

// Discounts
import DiscountsManagement from 'pages/discounts'
import DiscountsForm from 'pages/discounts/discountsForm/discountsForm'

// Station Distance Configuration
import StationDistanceConfig from 'pages/stationDistanceConfig'
import StationDistanceConfigForms from 'pages/stationDistanceConfig/stationDistanceConfigForms/stationDistanceConfigForms'
import NauticalMilesWallets from 'pages/nauticalMilesWallet'
import NauticalMilesWalletDetails from 'pages/nauticalMilesWallet/NauticalMilesWalletDetails'

// Round Routes
import RoundTrip from 'pages/roundTrip'
import RoundTripForm from 'pages/roundTrip/roundTripForm/roundTripForm'

// luggages
import Luggages from 'pages/luggagemaster'
import LuggageForm from 'pages/luggagemaster/luggageForm'

// referral config
import ReferralConfig from 'pages/referralConfig'
import ReferralForm from 'pages/referralConfig/referralConfigForm'
import UserMembership from 'pages/userMembership'
import ManageUserMembershipDetail from 'pages/userMembership/membershipDetails'
import ManageCharterBoat from 'pages/charterBoat'
import ManageCharterBoatForm from 'pages/charterBoat/charterBoatForm'
import UnipalConfig from 'pages/unipalConfig'
import UnipalForm from 'pages/unipalConfig/unipalConfigForm'
import UnipalServiceDetails from 'pages/unipalConfig/unipalConfigDetails'
import ManageRefundPolicy from 'pages/refunds'
import DashboardExecutive from 'pages/dashboard/executive_dashboard'

export const AppRoutes = () => (
    <Routes>
        {/* Home Route */}
        <Route path="/" element={<Home />} />
        {/* User List Route */}
        <Route
            path="/dashboard/executive"
            element={
                <ProtectedRoute>
                    <DashboardExecutive />
                </ProtectedRoute>
            }
        />
        <Route
            path="/dashboard"
            element={
                <ProtectedRoute>
                    <Dashboard />
                </ProtectedRoute>
            }
        />
        <Route
            path="/dashboard/revenue"
            element={
                <ProtectedRoute>
                    <RevenueDashboard />
                </ProtectedRoute>
            }
        />
        <Route
            path="/users"
            element={
                <ProtectedRoute>
                    <Users />
                </ProtectedRoute>
            }
        />
        <Route
            path="users/user-details/:id"
            element={
                <ProtectedRoute>
                    <UserDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="users/user-form"
            element={
                <ProtectedRoute>
                    <UserForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/boats"
            element={
                <ProtectedRoute>
                    <Boats />
                </ProtectedRoute>
            }
        />
        <Route
            path="boats/boat-details/:id"
            element={
                <ProtectedRoute>
                    <BoatDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="boats/boat-form"
            element={
                <ProtectedRoute>
                    <BoatForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="boats/boat-form/:id"
            element={
                <ProtectedRoute>
                    <BoatForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="vessel/checklist"
            element={
                <ProtectedRoute>
                    <CheckLists />
                </ProtectedRoute>
            }
        />
        <Route
            path="vessel/checklist/detail/:id/:submission_date"
            element={
                <ProtectedRoute>
                    <CheckListDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="vessel/defect-list"
            element={
                <ProtectedRoute>
                    <DefectLists />
                </ProtectedRoute>
            }
        />
        <Route
            path="vessel/defect-list/detail/:id/:submission_date"
            element={
                <ProtectedRoute>
                    <DefectListDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/metro-routes"
            element={
                <ProtectedRoute>
                    <MetroRoutes />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/metro-route-details/:id"
            element={
                <ProtectedRoute>
                    <MetroRouteDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/captain-details/:route_id/:trip_id"
            element={
                <ProtectedRoute>
                    <CaptainAssignmentDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/metro-route-form"
            element={
                <ProtectedRoute>
                    <MetroRouteForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/metro-route-form/:id"
            element={
                <ProtectedRoute>
                    <MetroRouteForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/metro-route-details/metro-trips/metro-trip-details/:id"
            element={
                <ProtectedRoute>
                    <MetroTripDetails />
                </ProtectedRoute>
            }
        />
        {/* Route Master */}
        <Route
            path="/metro-master-routes"
            element={
                <ProtectedRoute>
                    <MetroRoutesMaster />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-master-routes/metro-route-master-form"
            element={
                <ProtectedRoute>
                    <MetroRouteMasterForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-master-routes/metro-route-master-form/:id"
            element={
                <ProtectedRoute>
                    <MetroRouteMasterForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/metro-route-master-details/:id"
            element={
                <ProtectedRoute>
                    <MetroRouteMasterDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/location"
            element={
                <ProtectedRoute>
                    <Locations />
                </ProtectedRoute>
            }
        />
        <Route
            path="/location/location-form"
            element={
                <ProtectedRoute>
                    <LocationForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/location/location-form/:id"
            element={
                <ProtectedRoute>
                    <LocationForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/location/location-details/:id"
            element={
                <ProtectedRoute>
                    <LocationDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/luggages"
            element={
                <ProtectedRoute>
                    <Luggages />
                </ProtectedRoute>
            }
        />
        <Route
            path="/luggages/luggages-form"
            element={
                <ProtectedRoute>
                    <LuggageForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/luggages/Luggages-form/:id"
            element={
                <ProtectedRoute>
                    <LuggageForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/meals"
            element={
                <ProtectedRoute>
                    <Meals />
                </ProtectedRoute>
            }
        />

        <Route
            path="/meals/meal-form"
            element={
                <ProtectedRoute>
                    <MealForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/meals/meal-form/:id"
            element={
                <ProtectedRoute>
                    <MealForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/meals/meal-details/:id"
            element={
                <ProtectedRoute>
                    <MealDetails />
                </ProtectedRoute>
            }
        />

        <Route
            path="/day-pass/price"
            element={
                <ProtectedRoute>
                    <DayPass />
                </ProtectedRoute>
            }
        />
        <Route
            path="/day-pass/add-price/"
            element={
                <ProtectedRoute>
                    <DayPassForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/day-pass/add-price/:id"
            element={
                <ProtectedRoute>
                    <DayPassForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/day-pass/details/:id"
            element={
                <ProtectedRoute>
                    <DayPassDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/price-config/round-trip-price"
            element={
                <ProtectedRoute>
                    <RoundTrip />
                </ProtectedRoute>
            }
        />
        <Route
            path="/price-config/round-trip-price/add"
            element={
                <ProtectedRoute>
                    <RoundTripForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/price-config/round-trip-price/:id"
            element={
                <ProtectedRoute>
                    <RoundTripForm />
                </ProtectedRoute>
            }
        />

        <Route
            path="/price-config/charter-boat-price"
            element={
                <ProtectedRoute>
                    <ManageCharterBoat />
                </ProtectedRoute>
            }
        />
        <Route
            path="/price-config/charter-boat-price/add"
            element={
                <ProtectedRoute>
                    <ManageCharterBoatForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/price-config/charter-boat-price/:id"
            element={
                <ProtectedRoute>
                    <ManageCharterBoatForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/boat-booking"
            element={
                <ProtectedRoute>
                    <BoatBooking />
                </ProtectedRoute>
            }
        />
        <Route
            path="/boat-booking/detail"
            element={
                <ProtectedRoute>
                    <BoatBookingDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/boat-booking/reschedule"
            element={
                <ProtectedRoute>
                    <RescheduleBooking />
                </ProtectedRoute>
            }
        />
        <Route
            path="/boat-booking/conformation"
            element={
                <ProtectedRoute>
                    <BoatBookingConformation />
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-boat-booking"
            element={
                <ProtectedRoute>
                    <ManageBoatBooking />
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-boat-booking/details/:booking_id/:travel_date"
            element={
                <ProtectedRoute>
                    <ManageBoatBookingDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-boat-booking/details/:booking_id/:travel_date/:booking_type"
            element={
                <ProtectedRoute>
                    <ManageBoatBookingDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-refund-policy"
            element={
                <ProtectedRoute>
                    <ManageRefundPolicy />
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-refund-policy/details/:booking_id/:travel_date"
            element={
                <ProtectedRoute>
                    {/* <ManageBoatBookingDetail /> */}
                </ProtectedRoute>
            }
        />
        <Route
            path="/manage-refund-policy/details/:booking_id/:travel_date/:booking_type"
            element={
                <ProtectedRoute>
                    {/* <ManageBoatBookingDetail /> */}
                </ProtectedRoute>
            }
        />
        <Route
            path="/check-in"
            element={
                <ProtectedRoute>
                    <ManageBoatBooking isCheckInMode={true} />
                </ProtectedRoute>
            }
        />
        <Route
            path="/check-in/qr-scanner"
            element={
                <ProtectedRoute>
                    <QRScannerPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/check-in/passenger"
            element={
                <ProtectedRoute>
                    <CheckInPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/check-in/process"
            element={
                <ProtectedRoute>
                    <CheckInPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/user-membership"
            element={
                <ProtectedRoute>
                    <UserMembership />
                </ProtectedRoute>
            }
        />
        <Route
            path="/user-membership/details/:id"
            element={
                <ProtectedRoute>
                    <ManageUserMembershipDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/user-membership/details/:id"
            element={
                <ProtectedRoute>
                    <ManageUserMembershipDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/metro-trips/metro-trip-form/:route_id/:trip_id"
            element={
                <ProtectedRoute>
                    <MetroTripForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/captain-schedule-form"
            element={
                <ProtectedRoute>
                    <CaptainScheduleForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/captain-schedule-form/:id/:route_id/:trip_id/:trip_name"
            element={
                <ProtectedRoute>
                    <CaptainScheduleForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="metro-routes/boat-assign-form/:id/:route_id"
            element={
                <ProtectedRoute>
                    <BoatRouteAssignmentForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/route-operations"
            element={
                <ProtectedRoute>
                    <CaptainRouteBoatHistory />
                </ProtectedRoute>
            }
        />
        <Route
            path="/route-operations-details/:id"
            element={
                <ProtectedRoute>
                    <RouteBoatDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/passenger-record"
            element={
                <ProtectedRoute>
                    <PassengerRecord />
                </ProtectedRoute>
            }
        />
        <Route
            path="/passenger-record/:trip_id/passengers"
            element={
                <ProtectedRoute>
                    <TripPassengerList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/send-notification"
            element={
                <ProtectedRoute>
                    <SendNotification />
                </ProtectedRoute>
            }
        />
        <Route
            path="/app-banners"
            element={
                <ProtectedRoute>
                    <AppBanners />
                </ProtectedRoute>
            }
        />
        <Route
            path="/app-banners/add"
            element={
                <ProtectedRoute>
                    <AppBannerForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/app-banners/add/:id"
            element={
                <ProtectedRoute>
                    <AppBannerForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config"
            element={
                <ProtectedRoute>
                    <SystemConfig />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/discount"
            element={
                <ProtectedRoute>
                    <DiscountCodeForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/recipient-parties"
            element={
                <ProtectedRoute>
                    <RecipientParties />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/recipient-parties/add"
            element={
                <ProtectedRoute>
                    <RecipientPartyForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/recipient-parties/edit/:id"
            element={
                <ProtectedRoute>
                    <RecipientPartyForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/recipient-parties/details/:id"
            element={
                <ProtectedRoute>
                    <RecipientPartyDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/shuttle-services"
            element={
                <ProtectedRoute>
                    <ShuttleServiceMaster />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/shuttle-services/add"
            element={
                <ProtectedRoute>
                    <ShuttleServiceForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/shuttle-services/details/:id"
            element={
                <ProtectedRoute>
                    <ShuttleServiceDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="/system-config/shuttle-services/edit/:id"
            element={
                <ProtectedRoute>
                    <ShuttleServiceEditForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/feedback"
            element={
                <ProtectedRoute>
                    <Feedback />
                </ProtectedRoute>
            }
        />
        <Route
            path="/feedback/details/:id"
            element={
                <ProtectedRoute>
                    <FeedbackDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/day-pass"
            element={
                <ProtectedRoute>
                    <DayPassReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/bookings"
            element={
                <ProtectedRoute>
                    <BookingReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/trips"
            element={
                <ProtectedRoute>
                    <TripReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/route-performance"
            element={
                <ProtectedRoute>
                    <RouteUtilizationReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/station-revenue"
            element={
                <ProtectedRoute>
                    <StationRevenueReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/fleet-performance"
            element={
                <ProtectedRoute>
                    <FleetUtilizationReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/hourly-booking-performance"
            element={
                <ProtectedRoute>
                    <HourlyBookingReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/customer-feedback"
            element={
                <ProtectedRoute>
                    <CustomerFeedbackReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/nationality-summary"
            element={
                <ProtectedRoute>
                    <NationalityPassengerReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/attraction-clicks"
            element={
                <ProtectedRoute>
                    <AttractionsClicksReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="reports/banner-clicks"
            element={
                <ProtectedRoute>
                    <AppBannerClicksReport />
                </ProtectedRoute>
            }
        />
        <Route
            path="wallets/list"
            element={
                <ProtectedRoute>
                    <WalletList />
                </ProtectedRoute>
            }
        />
        <Route
            path="wallets/detail"
            element={
                <ProtectedRoute>
                    <WalletDetails />
                </ProtectedRoute>
            }
        />
        <Route
            path="nautical-miles-wallets/list"
            element={
                <ProtectedRoute>
                    <NauticalMilesWallets />
                </ProtectedRoute>
            }
        />
        <Route
            path="nautical-miles-wallets/detail"
            element={
                <ProtectedRoute>
                    <NauticalMilesWalletDetails />
                </ProtectedRoute>
            }
        />

        {/* Explore Items Routes */}
        <Route
            path="/explore-items"
            element={
                <ProtectedRoute>
                    <ExploreItems />
                </ProtectedRoute>
            }
        />
        <Route
            path="explore-items/add"
            element={
                <ProtectedRoute>
                    <ExploreItemForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="explore-items/edit/:id"
            element={
                <ProtectedRoute>
                    <ExploreItemForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="explore-items/details/:id"
            element={
                <ProtectedRoute>
                    <ExploreItemDetails />
                </ProtectedRoute>
            }
        />

        {/* App Users Routes */}
        <Route
            path="/app-users"
            element={
                <ProtectedRoute>
                    <AppUsers />
                </ProtectedRoute>
            }
        />
        <Route
            path="/app-users/bookings"
            element={
                <ProtectedRoute>
                    <UserBookings />
                </ProtectedRoute>
            }
        />
        <Route
            path="/app-users/user-details/:id"
            element={
                <ProtectedRoute>
                    <AppUserDetails />
                </ProtectedRoute>
            }
        />

        {/* Subscription Management Routes */}
        <Route
            path="/subscriptions"
            element={
                <ProtectedRoute>
                    <SubscriptionManagement />
                </ProtectedRoute>
            }
        />
        <Route
            path="/subscriptions/create"
            element={
                <ProtectedRoute>
                    <SubscriptionForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/subscriptions/edit/:code"
            element={
                <ProtectedRoute>
                    <SubscriptionForm />
                </ProtectedRoute>
            }
        />

        {/* Charter Boats Routes */}
        <Route
            path="/charter-boats/configuration"
            element={
                <ProtectedRoute>
                    <CharterBoatsConfiguration />
                </ProtectedRoute>
            }
        />
        <Route
            path="/charter-boats/configuration/add"
            element={
                <ProtectedRoute>
                    <ConfigurationForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/charter-boats/configuration/edit/:id"
            element={
                <ProtectedRoute>
                    <ConfigurationForm />
                </ProtectedRoute>
            }
        />

        {/* Discounts Routes */}
        <Route
            path="/discounts"
            element={
                <ProtectedRoute>
                    <DiscountsManagement />
                </ProtectedRoute>
            }
        />

        <Route
            path="/discounts/add"
            element={
                <ProtectedRoute>
                    <DiscountsForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/discounts/edit/:id"
            element={
                <ProtectedRoute>
                    <DiscountsForm />
                </ProtectedRoute>
            }
        />

        {/*Station Distance Configuration Routes*/}
        <Route
            path="/nautical-miles-distance"
            element={
                <ProtectedRoute>
                    <StationDistanceConfig />
                </ProtectedRoute>
            }
        />
        <Route
            path="/nautical-miles-distance/add"
            element={
                <ProtectedRoute>
                    <StationDistanceConfigForms />
                </ProtectedRoute>
            }
        />
        <Route
            path="/nautical-miles-distance/edit/:id"
            element={
                <ProtectedRoute>
                    <StationDistanceConfigForms />
                </ProtectedRoute>
            }
        />

        {/*Referral Configuration Routes*/}
        <Route
            path="/referral-config"
            element={
                <ProtectedRoute>
                    <ReferralConfig />
                </ProtectedRoute>
            }
        />
        <Route
            path="/referral-config/edit/:id"
            element={
                <ProtectedRoute>
                    <ReferralForm />
                </ProtectedRoute>
            }
        />

        {/* Unipal Config */}
        <Route
            path="/unipal-config"
            element={
                <ProtectedRoute>
                    <UnipalConfig />
                </ProtectedRoute>
            }
        />

        <Route
            path="/unipal-config/add"
            element={
                <ProtectedRoute>
                    <UnipalForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="/unipal-config/edit/:id"
            element={
                <ProtectedRoute>
                    <UnipalForm />
                </ProtectedRoute>
            }
        />
        <Route
            path="unipal-config/details/:id"
            element={
                <ProtectedRoute>
                    <UnipalServiceDetails />
                </ProtectedRoute>
            }
        />

        {/* Fallback Route */}
        <Route path="/" element={<Home />} />
    </Routes>
)
